import { useMemo, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MANAGE_AREA_TAX_LOCATION_TABLE } from '../../../constants/tableColumns';
import { routeConstants } from '../../../constants/routeConstants';
import { useGetManageAreaTaxLocationsQuery } from '../../../services/ManageAreaTaxLocations/ManageAreaTaxLocationsService';
import useAreaTaxFilters from './useAreaTaxFilters';
import useAreaTaxModals from './useAreaTaxModals';

const useAreaTaxLocationsTab = ({ status, isActiveTab, onTotalCount = () => {} }) => {
  const navigate = useNavigate();

  const filters = useAreaTaxFilters({ status });
  const modals = useAreaTaxModals();

  // Query params for RTK Query
  const queryParams = useMemo(
    () => ({
      page: filters?.tabFilters?.pageNumber || 1,
      perPage: filters?.tabFilters?.rowsPerPage || 10,
      searchParams: filters?.searchFilterData || '',
      status,
    }),
    [filters?.tabFilters?.pageNumber, filters?.tabFilters?.rowsPerPage, filters?.searchFilterData, status],
  );

  // Data fetching
  const {
    data: apiData,
    isLoading,
    isError,
    isFetching,
  } = useGetManageAreaTaxLocationsQuery(queryParams, {
    refetchOnMountOrArgChange: true,
    skip: !isActiveTab,
  });

  const tableData = useMemo(() => apiData?.areaTaxLocations || [], [apiData]);
  const totalCount = apiData?.pagination?.total || 0;

  const navigateToAddNew = useCallback(() => {
    navigate(
      `/${routeConstants.SETTING_ROUTE}/${routeConstants.MANAGE_AREA_TAX_LOCATION}/${routeConstants.ASSIGN_AREA_TAX_LOCATION}`,
    );
  }, [navigate]);

  useEffect(() => {
    if (!isActiveTab) return;
    if (isError) {
      onTotalCount(status, 0);
      return;
    }
    onTotalCount(status, totalCount);
  }, [isActiveTab, isError, onTotalCount, status, totalCount]);

  const columns = useMemo(() => MANAGE_AREA_TAX_LOCATION_TABLE() || [], []);

  return {
    ...filters,
    ...modals,
    tableData,
    totalCount,
    isLoading,
    isError,
    isFetching,
    columns,
    navigateToAddNew,
  };
};

export default useAreaTaxLocationsTab;
